import { render, staticRenderFns } from "./SchoolsDashPie.vue?vue&type=template&id=063e1527&scoped=true"
import script from "./SchoolsDashPie.vue?vue&type=script&lang=js"
export * from "./SchoolsDashPie.vue?vue&type=script&lang=js"
import style0 from "./SchoolsDashPie.vue?vue&type=style&index=0&id=063e1527&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063e1527",
  null
  
)

export default component.exports